export default "__VITE_ASSET__7f61ff63__"